import type { HsCameraToolType } from './camera-tool-type.enum';
import { HsControlActionType } from './control-action-type.enum';
import { HsControlAction } from './control-action.abstract';

/**
 * Handles s camera tool type control action.
 */
export class HsCameraToolTypeControlAction extends HsControlAction {
  public readonly actionType: HsControlActionType = HsControlActionType.CameraToolType;
  constructor(public cameraToolType: HsCameraToolType) {
    super();
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsCameraToolTypeControlAction)) {
      return;
    }

    this.cameraToolType = controlAction.cameraToolType;
  }
}
